import { render, staticRenderFns } from "./EmrSpecialtyMappingItem.vue?vue&type=template&id=775a14de&scoped=true"
import script from "./EmrSpecialtyMappingItem.vue?vue&type=script&lang=js"
export * from "./EmrSpecialtyMappingItem.vue?vue&type=script&lang=js"
import style0 from "./EmrSpecialtyMappingItem.vue?vue&type=style&index=0&id=775a14de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a14de",
  null
  
)

export default component.exports